import Main from '../../Main';
import { contentMap } from '../../../../textObjects/locations';
function MainDefault(){
return (
  <Main contentMap={contentMap}/>
);
}
export default MainDefault